const BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (process.env.NODE_ENV === 'production'
    ? 'https://api.bidders.network'
    : 'http://127.0.0.1:6001');

/** Browser URL for this dashboard SPA (nginx: app.*). Use `API_CONFIG` for API calls (api.*). */
export const DASHBOARD_PUBLIC_URL =
  (typeof process.env.REACT_APP_DASHBOARD_URL === 'string'
    ? process.env.REACT_APP_DASHBOARD_URL.trim().replace(/\/$/, '')
    : '') ||
  (process.env.NODE_ENV === 'production' ? 'https://app.bidders.network' : '');

export const API_CONFIG = {
  BASE_URL,
  API_BASE: process.env.REACT_APP_API_BASE || '/api',
  get FULL_API_URL() {
    return `${this.BASE_URL}${this.API_BASE}`;
  }
};
